const STATIC_WEB_USERNAME_DB_MAX_LENGTH = 32;
const DEFAULT_STATIC_WEB_USERNAME_MAX_LENGTH = 24;

function resolveStaticWebUsernameMaxLength() {
  const raw = Number(process.env.REACT_APP_STATIC_WEB_USERNAME_MAX_LENGTH);
  if (!Number.isFinite(raw)) return DEFAULT_STATIC_WEB_USERNAME_MAX_LENGTH;
  return Math.min(STATIC_WEB_USERNAME_DB_MAX_LENGTH, Math.max(3, Math.floor(raw)));
}

export const STATIC_WEB_USERNAME_MAX_LENGTH = resolveStaticWebUsernameMaxLength();
export const STATIC_WEB_USERNAME_DB_MAX = STATIC_WEB_USERNAME_DB_MAX_LENGTH;

export function isValidStaticWebUsername(value) {
  const candidate = String(value || "").trim();
  return (
    candidate.length >= 3 &&
    candidate.length <= STATIC_WEB_USERNAME_MAX_LENGTH &&
    /^[a-zA-Z0-9._-]+$/.test(candidate)
  );
}
